export interface HelpList { [route: string]: number }

export interface HelpState {
    helpList: HelpList
}

export const HELP_LIST = "HELP_LIST"
